import { defineMessages } from 'react-intl';

const messages = defineMessages({
  default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  headline: {
    id: 'Headline',
    defaultMessage: 'Headline',
  },
  headline_bg: {
    id: 'headline_bg',
    defaultMessage: 'Sfondo titolo',
  },
  items: {
    id: 'sponsorsItems',
    defaultMessage: 'Elementi',
  },
  item: {
    id: 'sponsorsItem',
    defaultMessage: 'Elemento',
  },
  addItem: {
    id: 'sponsorsAddItem',
    defaultMessage: 'Aggiungi elemento',
  },
  description: {
    id: 'description',
    defaultMessage: 'Descrizione',
  },
  link: {
    id: 'link',
    defaultMessage: 'Collegamento',
  },
});

export const SponsorsItemSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.item),
  addMessage: intl.formatMessage(messages.addItem),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.default),
      fields: ['description', 'sponsors'],
    },
  ],
  properties: {
    description: {
      title: intl.formatMessage(messages.description),
    },
    sponsors: {
      title: intl.formatMessage(messages.link),
      widget: 'object_browser',
      mode: 'link',
      selectedItemAttrs: ['Title', 'Description'],
      allowExternals: false,
      widgetOptions: {
        pattern_options: {
          selectableTypes: ['Link'],
        },
      },
    },
  },
  required: [],
});

export const SponsorsSchema = ({ intl }) => ({
  title: 'Sponsors',
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.default),
      fields: ['headline', 'headline_bg', 'items'],
    },
  ],
  properties: {
    headline: {
      title: intl.formatMessage(messages.headline),
    },
    headline_bg: {
      title: intl.formatMessage(messages.headline_bg),
      type: 'boolean',
    },
    items: {
      title: intl.formatMessage(messages.items),
      widget: 'object_list',
      schema: SponsorsItemSchema({ intl }),
    },
  },
  required: [],
});
